import { render, staticRenderFns } from "./RirekishoPreview.vue?vue&type=template&id=73308e1b"
import script from "./RirekishoPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./RirekishoPreview.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports